import { Link } from 'react-router-dom';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import {
  LBDrownHandIcon,
  LBTooltipProvider,
  LBTooltip,
  LBTooltipTrigger,
  LBTooltipContent,
  LBBenchmarkIndication
} from '@linearb/buzz';

const TooltipContent = ({ name }) => {
  return (
    <div className='flex items-center'>Looks like {name} has too much work</div>
  );
};

const Wip = ({ link, name, isTopReviewer, isBurnout }) => {
  const showWipText = !isTopReviewer && !isBurnout;
  return (
    <>
      {showWipText && (
        <div className='pr-2 text-sm' data-testid='wip-text'>
          WIP overload
        </div>
      )}
      <LBTooltipProvider key={name}>
        <LBTooltip>
          <LBTooltipTrigger className='overflow-hidden text-ellipsis'>
            <Link
              className='no-underline'
              to={link}
              onClick={() =>
                TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
                  page: TRACKING.PAGES.DASHBOARD,
                  click_type: TRACKING.CLICK.CONTRIBUTOR_BRANCHES
                })
              }
            >
              <LBBenchmarkIndication variant='fair' size='sm'>
                <LBDrownHandIcon />
              </LBBenchmarkIndication>
            </Link>
          </LBTooltipTrigger>
          <LBTooltipContent>
            <TooltipContent name={name} />
          </LBTooltipContent>
        </LBTooltip>
      </LBTooltipProvider>
    </>
  );
};

export default Wip;
